import {Injectable, ElementRef} from '@angular/core';
import {Subject} from 'rxjs';
import {DataService} from './dataIcar.service';
import {StateMitek} from '../../interfaces/scripts';
import {StorageService} from '../storage.service';

declare var mitekScienceSDK: any;

@Injectable()
export class MitekService {

  public $MitekServiceState: Subject<any> = new Subject<string>();

  timer; // Contador para la duracion del proceso de autocaptura
  recentHint = null; // Ultimo mensaje mostrado durante la autocaptura
  docType = '';

  docTypeHints = {
    MISNAP_HEAD_OUTSIDE: 'Coloca el rostro en el recuadro.',
    MISNAP_HEAD_SKEWED: 'Mira al frente',
    MISNAP_AXIS_ANGLE: 'Sostener el teléfono en posición vertical',
    MISNAP_HEAD_TOO_CLOSE: 'Alejate un poco',
    MISNAP_HEAD_TOO_FAR: 'Acercate un poco',
    MISNAP_STAY_STILL: 'Quédate quieto',
    MISNAP_SUCCESS: 'Captura realizada',
    MISNAP_STOP_SMILING: 'Deja de sonreir',
    MISNAP_SMILE: 'Sonrie!',
    MISNAP_READY_POSE: 'Mantente ahí',
    NO_FACE_FOUND: 'Rostro no detectado',
    MITEK_ERROR_GLARE: 'Disminuye el brillo',
    MITEK_ERROR_FOUR_CORNER: 'Documento no existente',

  };

  constructor(private data: DataService, private storage: StorageService) {
  }


  startVideoFace() {
    this.startAutoCapture('SELFIE');
  }

  performQualityCheck(imageData) {
    mitekScienceSDK.cmd('PROCESS_FRAME', {
      documentType: 'DL_FRONT',
      mitekSDKPath: './assets/js/mitekSDK/',
      //mitekSDKPath: "https://localhost/assets/js/mitekSDK/",
      options: {
        frame: imageData,
        qualityPercent: 95
      }
    });

    mitekScienceSDK.on('FRAME_PROCESSING_STARTED', function() {
    });

    mitekScienceSDK.on('FRAME_PROCESSING_FEEDBACK', function(result) {
      //console.log(result);
    });

    mitekScienceSDK.on('FRAME_CAPTURE_RESULT', function(result) {
      console.log('Direct Science Result', result);
      //debugger;
      //alert("Status: "+result.response.status+" Warnings ("+result.response.warnings.status+"): "+result.response.warnings.key);
      //TODO: Utilizar "result.imageData" como imagen para enviar al servicio de valicación.
    });

    mitekScienceSDK.on('SDK_ERROR', function(err) {
      //console.log('direct input error', err);
    });
  }

  startAutoCapture(docType) {

    console.log('Typeeeeee');
    console.log(docType);
    this.docType = docType;
    this.recentHint = '';
    // Desabilitamos el boton de autocaptura para evitar que se inicien dos autocapturas simultaneas

    // Evento al iniciar la camara del dispositivo
    mitekScienceSDK.on('CAMERA_DISPLAY_STARTED', function(result) {
      mitekScienceSDK.cmd('SHOW_HINT', 'Espero por favor');
      this.$MitekServiceState.next(StateMitek.STARTSDK);
    }.bind(this));


    // Evento de inicio de la autocaptura
    mitekScienceSDK.on('FRAME_PROCESSING_STARTED', function(result) {

      this.attemptTimer = setTimeout(function() {
        clearTimeout(this.attemptTimer);
        mitekScienceSDK.cmd('SDK_STOP');
        this.$MitekServiceState.next(StateMitek.STOPSDK);

      }, 250000);

      let self = this;
      this.hintTimer = setInterval(function() {
        if (this.recentHint !== null && this.recentHint !== undefined) {
          console.log(this.recentHint);
          mitekScienceSDK.cmd('SHOW_HINT', self.docTypeHints[self.recentHint]);
        }
      }, 500);

    }.bind(this));


    // CAPTURE FEEDBACK CHANNEL: during capture, feedback for frames that...i.e. Hint Messages
    mitekScienceSDK.on('FRAME_PROCESSING_FEEDBACK', function(result) {

      this.recentHint = result.key;

      if (this.docType === 'SELFIE') {

        let elem = document.querySelector('.integrator.SELFIE');
        // turn oval green if head is in guide
        if (result.key === 'MISNAP_SMILE' ||
          result.key === 'MISNAP_STOP_SMILING' ||
          result.key === 'MISNAP_READY_POSE') {

          elem.classList.add('FACE_IN_GUIDE');

        } else {

          elem.classList.remove('FACE_IN_GUIDE');
        }
        if (this.recentHint !== null) {

          mitekScienceSDK.cmd('SHOW_HINT', this.docTypeHints[this.recentHint]);
        }
      } else {

        if (this.recentHint !== null) {
          if (result.key == 'MITEK_ERROR_FOUR_CORNER' ||
            result.key == 'MITEK_ERROR_GLARE') {
            mitekScienceSDK.cmd('SHOW_HINT', this.docTypeHints[this.recentHint]);
          } else {
            this.recentHint = null;
          }
        }
      }
    }.bind(this));


    // Evento de captura realizada
    mitekScienceSDK.on('FRAME_CAPTURE_RESULT', function(result) {
      console.log('Evento de captura realizada');
      this.storage.saveToStorage('FACEBASE64', result.response.imageData.replace('data:image/jpeg;base64,', ''));
      this.$MitekServiceState.next(StateMitek.RESULTSDK);
    }.bind(this));


    // Evento SDK error
    mitekScienceSDK.on('SDK_ERROR', function(err) {
      console.log(err);
      this.$MitekServiceState.next(StateMitek.ERRORSDK);
    }.bind(this));

    mitekScienceSDK.cmd('CAPTURE_AND_PROCESS_FRAME', {
      mode: 'AUTO_CAPTURE',
      documentType: 'SELFIE',
      mitekSDKPath: './assets/js/mitekSDK/',
      //mitekSDKPath: "https://localhost/assets/js/mitekSDK/",
      options: {
        qualityPercent: 80
      }
    });
    window.scrollTo(0, 0);
  }
}
